import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-black/70 backdrop-blur-md py-5">
      <div className="max-w-screen-xl mx-auto text-center">
        <div className="flex justify-center gap-7 flex-wrap mb-3">
          <Link
            to="/games"
            className="text-white no-underline text-base transition-all duration-300 ease-in-out relative group hover:text-[#ff7f50] hover:-translate-y-0.5 after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-[#ff7f50] after:transition-all after:duration-300 hover:after:w-full"
          >
            Games
          </Link>
          <Link
            to="/careers"
            className="text-white no-underline text-base transition-all duration-300 ease-in-out relative group hover:text-[#ff7f50] hover:-translate-y-0.5 after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-[#ff7f50] after:transition-all after:duration-300 hover:after:w-full"
          >
            Careers
          </Link>
          {/* <Link
            to="/colors"
            className="text-white no-underline text-base transition-all duration-300 ease-in-out relative group hover:text-[#ff7f50] hover:-translate-y-0.5 after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-[#ff7f50] after:transition-all after:duration-300 hover:after:w-full"
          >
            Color Palette
          </Link> */}
          <Link
            to="/terms"
            className="text-white no-underline text-base transition-all duration-300 ease-in-out relative group hover:text-[#ff7f50] hover:-translate-y-0.5 after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-[#ff7f50] after:transition-all after:duration-300 hover:after:w-full"
          >
            Terms of Service
          </Link>
          <Link
            to="/privacy"
            className="text-white no-underline text-base transition-all duration-300 ease-in-out relative group hover:text-[#ff7f50] hover:-translate-y-0.5 after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-[#ff7f50] after:transition-all after:duration-300 hover:after:w-full"
          >
            Privacy Policy
          </Link>
        </div>
        <div className="text-white/70 text-sm">
          © {new Date().getFullYear()} Tales and Legends. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
